import { Maybe } from 'graphql/jsutils/Maybe'
import { IInsurancePolicyFragment } from './graphql/InsurancePoliciesFragment'

export const getLabel = (isType: Maybe<string>) => {
  switch (isType) {
    case 'automobile_liability':
      return 'Automobile'
    case 'motor_truck_cargo':
      return 'Cargo'
    case 'commercial_general_liability':
      return 'General'
    case 'workers_compensation':
      return 'Workers Comp'
    default:
      return null
  }
}

export const getIsExpired = (policy: IInsurancePolicyFragment) => {
  const now = new Date()
  const isExpired = new Date(policy.expirationDate) <= now
  return isExpired
}

export const getIsCoverageSufficent = (policy: IInsurancePolicyFragment) => {
  const isAuto = policy.isType === 'automobile_liability'
  const isCargo = policy.isType === 'motor_truck_cargo'
  const amount = policy.coverageLimit || '0'
  const amountAsNumber = parseInt(amount.replace(/,/g, ''), 10)
  const isExpired = getIsExpired(policy)

  if (isAuto && (amountAsNumber < 1000000 || isExpired)) return false
  if (isCargo && (amountAsNumber < 100000 || isExpired)) return false

  return true
}

export const getSinglePolicyStatus = (policy: IInsurancePolicyFragment) => {
  const isCoverageSufficent = getIsCoverageSufficent(policy)
  const status = policy.status || ''

  if (isCoverageSufficent && status === 'active') {
    return 'active'
  }

  if (status === 'pending_active') {
    return 'pending_active'
  }

  if (!isCoverageSufficent) return 'rejected'

  return 'inactive'
}

const getStrongerStatus = (status: string, acc: string) => {
  const isEitherActive = status === 'active' || acc === 'active'
  const isEitherPending = status === 'pending_active' || acc === 'pending_active'
  const isEitherInactive = status === 'inactive' || acc === 'inactive'
  const isEitherRejected = status === 'rejected' || acc === 'rejected'

  if (isEitherActive) return 'active'
  if (isEitherPending) return 'pending_active'
  if (isEitherInactive) return 'inactive'
  if (isEitherRejected) return 'rejected'

  return acc
}

export const getPolicyStatus = (acc: string, policy: IInsurancePolicyFragment) => {
  if (!policy) return acc

  const status = getSinglePolicyStatus(policy)

  const value = getStrongerStatus(status, acc)
  return value
}
